/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrColumnResizingSeparator } from './igr-column-resizing-separator';
import { ColumnResizingSeparator } from './ColumnResizingSeparator';
import { TypeRegistrar } from "igniteui-react-core";
var IgrColumnResizingSeparatorModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrColumnResizingSeparatorModule() {
    }
    IgrColumnResizingSeparatorModule.register = function () {
        TypeRegistrar.registerCons("IgrColumnResizingSeparator", IgrColumnResizingSeparator);
        TypeRegistrar.register("ColumnResizingSeparator", ColumnResizingSeparator.$type);
    };
    return IgrColumnResizingSeparatorModule;
}());
export { IgrColumnResizingSeparatorModule };
//# sourceMappingURL=igr-column-resizing-separator-module.js.map
